export default __webpack_public_path__ + "static/media/icon-share-highlighted.aee41408.svg";